import { FC } from 'react'

import {
  BarColor,
  Box,
  Card,
  Icon,
  InfoDot,
  ProgressBar,
  StackedBar,
  Text,
  Touchable,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { TaskAnalyticsData } from './analyticsData'

interface Prop {
  data: TaskAnalyticsData
  title: string
  touchable?: boolean
  touchingAction?: () => void
}
export const TaskAnalytics: FC<Prop> = ({
  data,
  title,
  touchable = false,
  touchingAction = () => null,
}) => {
  const { total, totalDueInfuture, totalOverDue, noDueDateTotal } = data
  const totalDueRelated = totalDueInfuture + totalOverDue + noDueDateTotal

  const stackBars: {
    title: string
    label: number
    value: number
    color: BarColor
  }[] = [
    {
      title: i18n.t('tasks.analytics.due'),
      label: totalDueInfuture,
      value: totalDueInfuture,
      color: ['viridian1000', 'viridian1000'],
    },
    {
      title: i18n.t('tasks.analytics.overdue'),
      label: totalOverDue,
      value: totalOverDue,
      color: ['radicalRed800', 'radicalRed800'],
    },
    {
      title: i18n.t('tasks.analytics.no_due'),
      label: noDueDateTotal,
      value: noDueDateTotal,
      color: ['grey600', 'grey600'],
    },
  ]

  const taskAnalyticsCard = (
    <Box width="s400" flexGrow>
      <Card>
        <Card.Content>
          <Box flexDirection="column" width="full" gap="s24">
            <Box flexDirection={touchable ? 'column' : 'row'} justifyContent="spaceBetween">
              <Box flexDirection="row" justifyContent="spaceBetween">
                <Text size="300" color="grey800" whiteSpace="nowrap">
                  {title}
                </Text>
                {touchable && (
                  <Box alignSelf="center" paddingTop="s2">
                    <Icon.Small color="grey700" icon="arrow-right" />
                  </Box>
                )}
              </Box>
              <Box flexDirection="row">
                <Text
                  weight={touchable ? 'medium' : 'semibold'}
                  size={touchable ? '600' : '300'}
                  color={touchable ? 'grey1000' : 'grey800'}
                >
                  {total}
                </Text>
              </Box>
            </Box>
            <Box gap="s12">
              {totalDueRelated > 0 ? (
                <StackedBar>
                  {stackBars.map(({ label, value, color }) => (
                    <StackedBar.Bar key={value} label={label} value={value} color={color} />
                  ))}
                </StackedBar>
              ) : (
                <ProgressBar
                  showLabel={false}
                  progressColor="viridian200"
                  amount={totalDueRelated}
                  total={100}
                />
              )}
              <Box flexDirection="row" width="full" gap="s8" justifyContent="spaceEvenly">
                {stackBars.map(({ title, color }, index) => (
                  <Box alignItems="center" width="full" key={index} gap="s8" flexDirection="row">
                    <InfoDot size="small" color={color[0]} />
                    <Text size="100" weight="medium" color="grey600">
                      {title}
                    </Text>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )

  return touchable ? (
    <Touchable onClick={touchingAction}>{taskAnalyticsCard}</Touchable>
  ) : (
    taskAnalyticsCard
  )
}
